module.exports = __webpack_public_path__ + "img/63.5.COD.9356a7e8.png";